// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3r1JQ","amount":"Amount_amount__11FQW","tip":"Amount_tip__3ObSL","tipHeader":"Amount_tipHeader__3ckAL","tipsWrap":"Amount_tipsWrap__2QpOy"};